import React, { Component } from "react";
import ContractATCForm from "./ContractATCForm";
import SmallModal from "../../../../hoc/UI/SmallModal/SmallModal";
import { Button } from "rsuite";

class ContractATC extends Component {
  state = {
    proj_contract_atc_id: null
  };

  componentDidMount() {
    this.props.contractATC.fetch();
  }
  render() {
    let smallModal = null;
    if (this.props.showSmallModal) {
      smallModal = (
        <SmallModal>
          <ContractATCForm
            toggleSmallModalHandler={this.props.toggleSmallModalHandler}
            currentContractATC={
              this.state.proj_contract_atc_id === null
                ? null
                : this.props.contractATC.contractATC.find(
                    contractATC =>
                      contractATC.proj_contract_atc_id ===
                      this.state.proj_contract_atc_id
                  )
            }
            update={this.props.contractATC.update}
            add={this.props.contractATC.add}
            projectID={this.props.currentProjectID}
            disabled={this.props.disabled}
          />
        </SmallModal>
      );
    }
    return (
      <div>
        {this.props.disabled ? null : (
          <div style={{ textAlign: "right" }}>
            <Button
              color={"blue"}
              className={"my-2"}
              onClick={() => {
                this.setState({ proj_contract_atc_id: null });
                this.props.toggleSmallModalHandler();
              }}
            >
              Create New Contract ATC
            </Button>
          </div>
        )}
        {smallModal}

        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Notes</th>
              {this.props.disabled ? null : <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {this.props.contractATC.contractATC.map(item => (
              <tr
                key={item.proj_contract_atc_id}
                onClick={e => {
                  if (e.target.type !== "button") {
                    this.setState({
                      proj_contract_atc_id: item.proj_contract_atc_id
                    });
                    this.props.toggleSmallModalHandler();
                  }
                }}
              >
                <td>{item.name}</td>
                <td>{item.notes}</td>
                {this.props.disabled ? null : (
                  <td>
                    <Button
                      color="blue"
                      type="button"
                      onClick={() => {
                        this.setState({
                          proj_contract_atc_id: item.proj_contract_atc_id
                        });
                        this.props.toggleSmallModalHandler();
                      }}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      color={"red"}
                      type="button"
                      onClick={() =>
                        this.props.contractATC.delete(
                          item.proj_contract_atc_id,
                          this.props.currentProjectID
                        )
                      }
                    >
                      Delete
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ContractATC;
